export function sortWorkspacesByName<T extends { name: string }>(
  workspaces: readonly T[],
): T[] {
  return [...workspaces].sort((left, right) =>
    left.name.localeCompare(right.name, undefined, { sensitivity: 'base' }),
  )
}
